import React from 'react';
import AutoComplete from 'material-ui/AutoComplete';

export default props => (
  <AutoComplete
    menuStyle={{
      maxHeight: 300,
      overflow: 'auto',
    }}
    {...props.inputProps}
    {...props.input}
    searchText={
      props.inputProps.dataSourceConfig && props.inputProps.dataSource && props.inputProps.dataSource.find
        ? (props.inputProps.dataSource.find(item => item[props.inputProps.dataSourceConfig.value] === props.input.value) || {})[props.inputProps.dataSourceConfig.text]
        : props.input.value
    }
    onNewRequest={value => {
      props.input.onChange(typeof value === 'object' && props.inputProps.dataSourceConfig ? value[props.inputProps.dataSourceConfig.value] : { value });
    }}
    errorText={props.meta.visited && props.meta.error && props.meta.error}
  />
);



// WEBPACK FOOTER //
// src/modules/forms/components/AutoCompleteField.js